/**
 * Frases de los personajes de One Piece para el tablero.
 *
 * Mezcla de citas reconocibles de la serie (algunas resumidas o adaptadas
 * para que quepan en la tarjeta) y frases originales escritas en la voz de
 * cada personaje. No todas son textuales.
 */

export interface Quote {
  id: string
  avatarId: string
  text: {
    es: string
    en: string
  }
}

export const quotes: Quote[] = [
  // ============================================
  // Capitán Paja (Luffy) - captain-straw
  // ============================================
  {
    id: 'luffy-1',
    avatarId: 'captain-straw',
    text: {
      es: '¡Yo seré el Rey de los Piratas!',
      en: "I'm gonna be the King of the Pirates!",
    },
  },
  {
    id: 'luffy-2',
    avatarId: 'captain-straw',
    text: {
      es: '¿Héroe? ¡No! Los héroes reparten la carne. ¡Yo quiero toda la carne para mí!',
      en: 'A hero? No! Heroes share their meat. I want all the meat for myself!',
    },
  },
  {
    id: 'luffy-3',
    avatarId: 'captain-straw',
    text: {
      es: 'No importa lo difícil que sea: ¡yo no me rindo!',
      en: "No matter how hard it is, I don't give up!",
    },
  },
  {
    id: 'luffy-4',
    avatarId: 'captain-straw',
    text: {
      es: '¡Vamos a la aventura!',
      en: "Let's go on an adventure!",
    },
  },
  {
    id: 'luffy-5',
    avatarId: 'captain-straw',
    text: {
      es: '¡Tengo hambre! Primero comemos y después vemos.',
      en: "I'm hungry! We eat first and figure it out later.",
    },
  },
  {
    id: 'luffy-6',
    avatarId: 'captain-straw',
    text: {
      es: 'No sé usar espadas, ni navegar, ni cocinar, ni mentir. ¡Sé que necesito ayuda para sobrevivir!',
      en: "I can't use swords, navigate, cook or lie. I know I need help to survive!",
    },
  },
  {
    id: 'luffy-7',
    avatarId: 'captain-straw',
    text: {
      es: '¡Este sombrero es mi tesoro!',
      en: 'This hat is my treasure!',
    },
  },
  {
    id: 'luffy-8',
    avatarId: 'captain-straw',
    text: {
      es: 'No quiero conquistar nada. El Rey de los Piratas es el más libre de todo el mar.',
      en: "I don't want to conquer anything. The Pirate King is the one with the most freedom on the sea.",
    },
  },
  {
    id: 'luffy-9',
    avatarId: 'captain-straw',
    text: {
      es: '¡Nami! ¡Eres mi compañera!',
      en: "Nami! You're my friend!",
    },
  },
  {
    id: 'luffy-10',
    avatarId: 'captain-straw',
    text: {
      es: '¡Si me rindo ahora, me voy a arrepentir!',
      en: "If I give up now, I'll regret it!",
    },
  },
  {
    id: 'luffy-11',
    avatarId: 'captain-straw',
    text: {
      es: '¡Todavía tengo a mis amigos!',
      en: 'I still have my friends!',
    },
  },
  {
    id: 'luffy-12',
    avatarId: 'captain-straw',
    text: {
      es: '¡No quiero una aventura aburrida!',
      en: "I don't want a boring adventure!",
    },
  },
  {
    id: 'luffy-13',
    avatarId: 'captain-straw',
    text: {
      es: 'Si no te arriesgas, no puedes construir un futuro.',
      en: "If you don't take risks, you can't create a future.",
    },
  },
  {
    id: 'luffy-14',
    avatarId: 'captain-straw',
    text: {
      es: '¡Sanji! ¡Comida!',
      en: 'Sanji! Food!',
    },
  },
  {
    id: 'luffy-15',
    avatarId: 'captain-straw',
    text: {
      es: '¡Sin ti no puedo ser el Rey de los Piratas!',
      en: "Without you, I can't become the King of the Pirates!",
    },
  },

  // ============================================
  // Espadachín Verde (Zoro) - green-swordsman
  // ============================================
  {
    id: 'zoro-1',
    avatarId: 'green-swordsman',
    text: {
      es: 'No pasó... nada.',
      en: 'Nothing... happened.',
    },
  },
  {
    id: 'zoro-2',
    avatarId: 'green-swordsman',
    text: {
      es: 'Cuando decidí seguir mi sueño, lo aposté todo.',
      en: 'When I decided to follow my dream, I bet everything on it.',
    },
  },
  {
    id: 'zoro-3',
    avatarId: 'green-swordsman',
    text: {
      es: 'Hasta vencerlo y ser el mejor espadachín del mundo, ¡no volveré a perder!',
      en: "Until I defeat him and become the world's greatest swordsman, I will never lose again!",
    },
  },
  {
    id: 'zoro-4',
    avatarId: 'green-swordsman',
    text: {
      es: 'Un espadachín nunca le da la espalda a un reto.',
      en: 'A swordsman never turns his back on a challenge.',
    },
  },
  {
    id: 'zoro-5',
    avatarId: 'green-swordsman',
    text: {
      es: 'Si ni siquiera puedo proteger el sueño de mi capitán, mi ambición no es más que palabras.',
      en: "If I can't even protect my captain's dream, my ambition is nothing but talk.",
    },
  },
  {
    id: 'zoro-6',
    avatarId: 'green-swordsman',
    text: {
      es: 'No tengo ninguna intención de perder.',
      en: 'I have no intention of losing.',
    },
  },
  {
    id: 'zoro-7',
    avatarId: 'green-swordsman',
    text: {
      es: 'Hoy entreno más que ayer. Mañana, más que hoy.',
      en: 'Today I train harder than yesterday. Tomorrow, harder than today.',
    },
  },
  {
    id: 'zoro-8',
    avatarId: 'green-swordsman',
    text: {
      es: 'Hay alguien a quien debo volver a ver. Hasta ese día, no pienso caer.',
      en: "There's someone I must meet again. Until that day, I won't fall.",
    },
  },
  {
    id: 'zoro-9',
    avatarId: 'green-swordsman',
    text: {
      es: '¡Seré el mejor espadachín del mundo! Se lo prometí a una amiga.',
      en: "I'll be the world's greatest swordsman! I promised a friend.",
    },
  },
  {
    id: 'zoro-10',
    avatarId: 'green-swordsman',
    text: {
      es: 'Tres espadas, un solo objetivo.',
      en: 'Three swords, one goal.',
    },
  },
  {
    id: 'zoro-11',
    avatarId: 'green-swordsman',
    text: {
      es: 'Nunca me he arrepentido de nada de lo que he hecho.',
      en: "I've never regretted anything I've done.",
    },
  },
  {
    id: 'zoro-12',
    avatarId: 'green-swordsman',
    text: {
      es: 'Una tripulación cuyo capitán pierde la dignidad termina por desmoronarse.',
      en: 'A crew whose captain has lost his dignity will surely fall apart.',
    },
  },
  {
    id: 'zoro-13',
    avatarId: 'green-swordsman',
    text: {
      es: 'Una buena siesta y quedo listo para lo que venga.',
      en: "A good nap and I'm ready for anything.",
    },
  },
  {
    id: 'zoro-14',
    avatarId: 'green-swordsman',
    text: {
      es: 'El dolor de hoy es la fuerza de mañana.',
      en: "Today's pain is tomorrow's strength.",
    },
  },
  {
    id: 'zoro-15',
    avatarId: 'green-swordsman',
    text: {
      es: 'No me perdí. Alguien movió el norte.',
      en: "I'm not lost. Someone moved north.",
    },
  },

  // ============================================
  // Navegante Naranja (Nami) - orange-navigator
  // ============================================
  {
    id: 'nami-1',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Lo único que amo en este mundo es el dinero y las mandarinas!',
      en: 'The only things I love in this world are money and tangerines!',
    },
  },
  {
    id: 'nami-2',
    avatarId: 'orange-navigator',
    text: {
      es: 'Luffy... ayúdame.',
      en: 'Luffy... help me.',
    },
  },
  {
    id: 'nami-3',
    avatarId: 'orange-navigator',
    text: {
      es: 'Una buena navegante siempre lee el cielo antes de zarpar.',
      en: 'A good navigator always reads the sky before setting sail.',
    },
  },
  {
    id: 'nami-4',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Voy a dibujar un mapa del mundo entero!',
      en: "I'm going to draw a map of the whole world!",
    },
  },
  {
    id: 'nami-5',
    avatarId: 'orange-navigator',
    text: {
      es: 'El mar no perdona a quien no se prepara.',
      en: "The sea doesn't forgive those who don't prepare.",
    },
  },
  {
    id: 'nami-6',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Déjenme el rumbo a mí! Yo sé por dónde ir.',
      en: 'Leave the course to me! I know the way.',
    },
  },
  {
    id: 'nami-7',
    avatarId: 'orange-navigator',
    text: {
      es: 'Cada isla tiene su clima. Cada día, su plan.',
      en: 'Every island has its weather. Every day, its plan.',
    },
  },
  {
    id: 'nami-8',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Cuentas claras, amistades largas!',
      en: 'Clear accounts make for lasting friendships!',
    },
  },
  {
    id: 'nami-9',
    avatarId: 'orange-navigator',
    text: {
      es: 'Va a llover en cinco minutos. Créanme.',
      en: "It's going to rain in five minutes. Trust me.",
    },
  },
  {
    id: 'nami-10',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Nadie toca mis mandarinas!',
      en: 'Nobody touches my tangerines!',
    },
  },
  {
    id: 'nami-11',
    avatarId: 'orange-navigator',
    text: {
      es: '¿De qué sirve un tesoro si estoy sola?',
      en: "What good is a treasure if I'm alone?",
    },
  },
  {
    id: 'nami-12',
    avatarId: 'orange-navigator',
    text: {
      es: 'En el Grand Line el clima cambia en un segundo. Hay que estar lista.',
      en: 'On the Grand Line the weather changes in a second. You have to be ready.',
    },
  },
  {
    id: 'nami-13',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Con esta tripulación nunca hay un día aburrido!',
      en: "With this crew there's never a boring day!",
    },
  },
  {
    id: 'nami-14',
    avatarId: 'orange-navigator',
    text: {
      es: 'Un buen plan vale más que mil espadas.',
      en: 'A good plan is worth more than a thousand swords.',
    },
  },
  {
    id: 'nami-15',
    avatarId: 'orange-navigator',
    text: {
      es: '¡Luffy, ese dinero no es para carne!',
      en: 'Luffy, that money is not for meat!',
    },
  },

  // ============================================
  // Chef Rubio (Sanji) - blonde-chef
  // ============================================
  {
    id: 'sanji-1',
    avatarId: 'blonde-chef',
    text: {
      es: 'En el Baratie aprendí a atender a cada cliente como si fuera el único.',
      en: 'At the Baratie I learned to treat every customer as if they were the only one.',
    },
  },
  {
    id: 'sanji-2',
    avatarId: 'blonde-chef',
    text: {
      es: 'El All Blue existe. ¡Y lo voy a encontrar!',
      en: "The All Blue exists. And I'm going to find it!",
    },
  },
  {
    id: 'sanji-3',
    avatarId: 'blonde-chef',
    text: {
      es: '¡No le perdono a nadie que desperdicie comida!',
      en: "I won't forgive anyone who wastes food!",
    },
  },
  {
    id: 'sanji-4',
    avatarId: 'blonde-chef',
    text: {
      es: 'Cocinar para los amigos es el mejor trabajo del mundo.',
      en: 'Cooking for your friends is the best job in the world.',
    },
  },
  {
    id: 'sanji-5',
    avatarId: 'blonde-chef',
    text: {
      es: 'Un buen plato se sirve caliente y con una sonrisa.',
      en: 'A good dish is served hot and with a smile.',
    },
  },
  {
    id: 'sanji-6',
    avatarId: 'blonde-chef',
    text: {
      es: 'Si alguien tiene hambre, le doy de comer. Así de simple.',
      en: "If someone's hungry, I feed them. It's that simple.",
    },
  },
  {
    id: 'sanji-7',
    avatarId: 'blonde-chef',
    text: {
      es: 'El amor es el mejor condimento.',
      en: 'Love is the best seasoning.',
    },
  },
  {
    id: 'sanji-8',
    avatarId: 'blonde-chef',
    text: {
      es: 'Mi cocina es mi taller: ahí todo tiene su lugar.',
      en: 'My kitchen is my workshop: everything has its place.',
    },
  },
  {
    id: 'sanji-9',
    avatarId: 'blonde-chef',
    text: {
      es: 'Un buen cocinero prueba todo antes de servirlo.',
      en: 'A good cook tastes everything before serving it.',
    },
  },
  {
    id: 'sanji-10',
    avatarId: 'blonde-chef',
    text: {
      es: 'Mis manos son para cocinar. Las cuido como mi mayor tesoro.',
      en: 'My hands are for cooking. I look after them like my greatest treasure.',
    },
  },
  {
    id: 'sanji-11',
    avatarId: 'blonde-chef',
    text: {
      es: 'El viejo Zeff me enseñó que el hambre no se le desea a nadie.',
      en: "Old man Zeff taught me that you wouldn't wish hunger on anyone.",
    },
  },
  {
    id: 'sanji-12',
    avatarId: 'blonde-chef',
    text: {
      es: 'Un caballero cumple su palabra, pase lo que pase.',
      en: 'A gentleman keeps his word, no matter what.',
    },
  },
  {
    id: 'sanji-13',
    avatarId: 'blonde-chef',
    text: {
      es: '¡La comida está lista! ¡Todos a la mesa!',
      en: "Food's ready! Everyone to the table!",
    },
  },
  {
    id: 'sanji-14',
    avatarId: 'blonde-chef',
    text: {
      es: 'Mi sueño vale más que mi orgullo.',
      en: 'My dream is worth more than my pride.',
    },
  },
  {
    id: 'sanji-15',
    avatarId: 'blonde-chef',
    text: {
      es: 'Vuelve cuando quieras. De mi cocina nadie se va con hambre.',
      en: 'Come back anytime. Nobody leaves my kitchen hungry.',
    },
  },

  // ============================================
  // Doctor Adorable (Chopper) - cute-doctor
  // ============================================
  {
    id: 'chopper-1',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Que me elogies no me pone feliz! ...Bueno, un poquito sí.',
      en: "Your compliments don't make me happy! ...Okay, maybe a little.",
    },
  },
  {
    id: 'chopper-2',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Seré un doctor que pueda curar cualquier enfermedad!',
      en: "I'll be a doctor who can cure any disease!",
    },
  },
  {
    id: 'chopper-3',
    avatarId: 'cute-doctor',
    text: {
      es: '¡No soy un mapache! ¡Soy un reno!',
      en: "I'm not a raccoon dog! I'm a reindeer!",
    },
  },
  {
    id: 'chopper-4',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Tengo que estudiar más! Hay tantas medicinas que no conozco.',
      en: "I have to study more! There are so many medicines I don't know.",
    },
  },
  {
    id: 'chopper-5',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Yo también voy a ser un gran pirata!',
      en: "I'm going to be a great pirate too!",
    },
  },
  {
    id: 'chopper-6',
    avatarId: 'cute-doctor',
    text: {
      es: 'Un doctor nunca se rinde con un paciente.',
      en: 'A doctor never gives up on a patient.',
    },
  },
  {
    id: 'chopper-7',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Soy el médico de los Sombrero de Paja!',
      en: "I'm the Straw Hats' doctor!",
    },
  },
  {
    id: 'chopper-8',
    avatarId: 'cute-doctor',
    text: {
      es: 'Quería parecer humano para tener amigos. ¡Ahora quiero ser un monstruo que ayude a Luffy!',
      en: 'I wanted to look human to have friends. Now I want to be a monster who helps Luffy!',
    },
  },
  {
    id: 'chopper-9',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Que no soy comida de emergencia!',
      en: "I'm not emergency food!",
    },
  },
  {
    id: 'chopper-10',
    avatarId: 'cute-doctor',
    text: {
      es: '¡El algodón de azúcar es lo mejor del mundo!',
      en: 'Cotton candy is the best thing in the world!',
    },
  },
  {
    id: 'chopper-11',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Un doctor! ¡Llamen a un doctor! ...Ah, cierto, el doctor soy yo.',
      en: "A doctor! Somebody call a doctor! ...Oh, right, I'm the doctor.",
    },
  },
  {
    id: 'chopper-12',
    avatarId: 'cute-doctor',
    text: {
      es: 'Descansar también es parte del tratamiento.',
      en: 'Resting is part of the treatment too.',
    },
  },
  {
    id: 'chopper-13',
    avatarId: 'cute-doctor',
    text: {
      es: '¡Aunque sea pequeño, puedo ser de gran ayuda!',
      en: "Even though I'm small, I can be a big help!",
    },
  },
  {
    id: 'chopper-14',
    avatarId: 'cute-doctor',
    text: {
      es: 'Un verdadero doctor cura el cuerpo y también el corazón.',
      en: 'A true doctor heals the body and the heart.',
    },
  },
  {
    id: 'chopper-15',
    avatarId: 'cute-doctor',
    text: {
      es: 'El Dr. Hiluluk nunca dejó de creer en lo imposible. Yo tampoco.',
      en: 'Dr. Hiluluk never stopped believing in the impossible. Neither will I.',
    },
  },

  // ============================================
  // Erudita Misteriosa (Robin) - dark-scholar
  // ============================================
  {
    id: 'robin-1',
    avatarId: 'dark-scholar',
    text: {
      es: '¡Quiero vivir! ¡Llévenme al mar con ustedes!',
      en: 'I want to live! Take me out to sea with you!',
    },
  },
  {
    id: 'robin-2',
    avatarId: 'dark-scholar',
    text: {
      es: 'Fufufu... Qué interesante.',
      en: 'Fufufu... How interesting.',
    },
  },
  {
    id: 'robin-3',
    avatarId: 'dark-scholar',
    text: {
      es: 'El conocimiento es el tesoro más valioso.',
      en: 'Knowledge is the most valuable treasure.',
    },
  },
  {
    id: 'robin-4',
    avatarId: 'dark-scholar',
    text: {
      es: 'Quiero conocer la verdadera historia del mundo.',
      en: 'I want to know the true history of the world.',
    },
  },
  {
    id: 'robin-5',
    avatarId: 'dark-scholar',
    text: {
      es: 'Los poneglyphs guardan los secretos del Siglo Vacío.',
      en: 'The Poneglyphs hold the secrets of the Void Century.',
    },
  },
  {
    id: 'robin-6',
    avatarId: 'dark-scholar',
    text: {
      es: 'Cada respuesta abre una pregunta nueva. Eso me encanta.',
      en: 'Every answer opens a new question. I love that.',
    },
  },
  {
    id: 'robin-7',
    avatarId: 'dark-scholar',
    text: {
      es: 'Leer un poco cada día hace una gran diferencia.',
      en: 'Reading a little every day makes a big difference.',
    },
  },
  {
    id: 'robin-8',
    avatarId: 'dark-scholar',
    text: {
      es: 'Cada persona tiene una historia que merece ser escuchada.',
      en: 'Every person has a story that deserves to be heard.',
    },
  },
  {
    id: 'robin-9',
    avatarId: 'dark-scholar',
    text: {
      es: 'Saul me enseñó a reír, incluso en los peores días.',
      en: 'Saul taught me to laugh, even on the worst days.',
    },
  },
  {
    id: 'robin-10',
    avatarId: 'dark-scholar',
    text: {
      es: 'Con paciencia, hasta la piedra más antigua termina hablando.',
      en: 'With patience, even the oldest stone ends up speaking.',
    },
  },
  {
    id: 'robin-11',
    avatarId: 'dark-scholar',
    text: {
      es: 'Pasé veinte años sola. Ahora tengo amigos que me cuidan.',
      en: 'I spent twenty years alone. Now I have friends who look out for me.',
    },
  },
  {
    id: 'robin-12',
    avatarId: 'dark-scholar',
    text: {
      es: 'Los libros son ventanas al pasado.',
      en: 'Books are windows to the past.',
    },
  },
  {
    id: 'robin-13',
    avatarId: 'dark-scholar',
    text: {
      es: 'Una taza de café y un buen libro: no pido más.',
      en: "A cup of coffee and a good book: that's all I ask.",
    },
  },
  {
    id: 'robin-14',
    avatarId: 'dark-scholar',
    text: {
      es: 'Cada civilización deja su huella.',
      en: 'Every civilization leaves its mark.',
    },
  },
  {
    id: 'robin-15',
    avatarId: 'dark-scholar',
    text: {
      es: 'La arqueología revela verdades ocultas.',
      en: 'Archaeology reveals hidden truths.',
    },
  },

  // ============================================
  // Mecánico SUPER (Franky) - super-mechanic
  // ============================================
  {
    id: 'franky-1',
    avatarId: 'super-mechanic',
    text: {
      es: '¡SÚÚÚPER!',
      en: 'SUUUUPER!',
    },
  },
  {
    id: 'franky-2',
    avatarId: 'super-mechanic',
    text: {
      es: '¡Hoy es un día SÚPER para construir algo nuevo!',
      en: 'Today is a SUPER day to build something new!',
    },
  },
  {
    id: 'franky-3',
    avatarId: 'super-mechanic',
    text: {
      es: '¡Esta semana estoy SÚÚÚPER!',
      en: "This week I'm SUUUUPER!",
    },
  },
  {
    id: 'franky-4',
    avatarId: 'super-mechanic',
    text: {
      es: '¡El Thousand Sunny es mi obra maestra!',
      en: 'The Thousand Sunny is my masterpiece!',
    },
  },
  {
    id: 'franky-5',
    avatarId: 'super-mechanic',
    text: {
      es: '¡Funciono a base de cola!',
      en: 'I run on cola!',
    },
  },
  {
    id: 'franky-6',
    avatarId: 'super-mechanic',
    text: {
      es: 'Mi sueño es construir un barco que le dé la vuelta al mundo.',
      en: 'My dream is to build a ship that sails around the world.',
    },
  },
  {
    id: 'franky-7',
    avatarId: 'super-mechanic',
    text: {
      es: '¡Construye con el corazón y tus creaciones durarán para siempre!',
      en: 'Build with your heart and your creations will last forever!',
    },
  },
  {
    id: 'franky-8',
    avatarId: 'super-mechanic',
    text: {
      es: '¿Algo se rompió? ¡Se arregla! Para eso estoy yo.',
      en: "Something broke? We fix it! That's what I'm here for.",
    },
  },
  {
    id: 'franky-9',
    avatarId: 'super-mechanic',
    text: {
      es: '¡No importa de qué estés hecho, lo que importa es tu espíritu!',
      en: "It doesn't matter what you're made of, what matters is your spirit!",
    },
  },
  {
    id: 'franky-10',
    avatarId: 'super-mechanic',
    text: {
      es: 'El acero también tiene corazón.',
      en: 'Steel has a heart too.',
    },
  },
  {
    id: 'franky-11',
    avatarId: 'super-mechanic',
    text: {
      es: 'Los sueños son el combustible que mueve el mundo.',
      en: 'Dreams are the fuel that moves the world.',
    },
  },
  {
    id: 'franky-12',
    avatarId: 'super-mechanic',
    text: {
      es: 'Tom-san me enseñó a responder por cada barco que construyo.',
      en: 'Tom-san taught me to take responsibility for every ship I build.',
    },
  },
  {
    id: 'franky-13',
    avatarId: 'super-mechanic',
    text: {
      es: '¡Mi cuerpo es una obra de arte!',
      en: 'My body is a work of art!',
    },
  },
  {
    id: 'franky-14',
    avatarId: 'super-mechanic',
    text: {
      es: '¡No estoy llorando! ...Es que me entró algo en el ojo.',
      en: "I'm not crying! ...I just got something in my eye.",
    },
  },
  {
    id: 'franky-15',
    avatarId: 'super-mechanic',
    text: {
      es: 'Un carpintero de barcos vive en sus creaciones.',
      en: 'A shipwright lives on in his creations.',
    },
  },

  // ============================================
  // Músico del Alma (Brook) - soul-musician
  // ============================================
  {
    id: 'brook-1',
    avatarId: 'soul-musician',
    text: {
      es: '¡Yohohoho! ¡La música es el lenguaje del alma!',
      en: 'Yohohoho! Music is the language of the soul!',
    },
  },
  {
    id: 'brook-2',
    avatarId: 'soul-musician',
    text: {
      es: 'Una promesa es para siempre. Yo siempre cumplo las mías.',
      en: 'A promise is forever. I always keep mine.',
    },
  },
  {
    id: 'brook-3',
    avatarId: 'soul-musician',
    text: {
      es: '¡Qué alegría verlos! Se me ilumina la cara... aunque no tengo cara. ¡Yohohoho!',
      en: 'So happy to see you! My face lights up... though I have no face. Yohohoho!',
    },
  },
  {
    id: 'brook-4',
    avatarId: 'soul-musician',
    text: {
      es: 'Por más larga que sea la noche, siempre llega el día.',
      en: 'No matter how deep the night, it always turns to day.',
    },
  },
  {
    id: 'brook-5',
    avatarId: 'soul-musician',
    text: {
      es: 'La música une los corazones.',
      en: 'Music connects hearts.',
    },
  },
  {
    id: 'brook-6',
    avatarId: 'soul-musician',
    text: {
      es: 'Le prometí a Laboon que volvería. Y voy a cumplir.',
      en: "I promised Laboon I'd come back. And I will.",
    },
  },
  {
    id: 'brook-7',
    avatarId: 'soul-musician',
    text: {
      es: 'Soul King Brook, a su servicio.',
      en: 'Soul King Brook, at your service.',
    },
  },
  {
    id: 'brook-8',
    avatarId: 'soul-musician',
    text: {
      es: '¡Esto me hiela hasta los huesos! ...Aunque solo soy huesos. ¡Yohohoho!',
      en: "This chills me to the bone! ...Though I'm only bones. Yohohoho!",
    },
  },
  {
    id: 'brook-9',
    avatarId: 'soul-musician',
    text: {
      es: '¡Tanta emoción que el corazón se me sale del pecho! ...Aunque no tengo corazón. ¡Yohohoho!',
      en: "I'm so excited my heart's about to burst! ...Though I have no heart. Yohohoho!",
    },
  },
  {
    id: 'brook-10',
    avatarId: 'soul-musician',
    text: {
      es: 'Mi afro sobrevivió cincuenta años. Es mi orgullo.',
      en: "My afro survived fifty years. It's my pride.",
    },
  },
  {
    id: 'brook-11',
    avatarId: 'soul-musician',
    text: {
      es: 'Lo que me mueve no son los músculos: es la música.',
      en: "What moves me isn't muscle: it's music.",
    },
  },
  {
    id: 'brook-12',
    avatarId: 'soul-musician',
    text: {
      es: '¡Yohohoho! Un día sin música es un día perdido.',
      en: 'Yohohoho! A day without music is a day wasted.',
    },
  },
  {
    id: 'brook-13',
    avatarId: 'soul-musician',
    text: {
      es: 'Pasé cincuenta años solo. Por eso hoy disfruto cada día en compañía.',
      en: "I spent fifty years alone. That's why I enjoy every day with company now.",
    },
  },
  {
    id: 'brook-14',
    avatarId: 'soul-musician',
    text: {
      es: 'Practico todos los días. ¡Un músico nunca deja de aprender!',
      en: 'I practice every day. A musician never stops learning!',
    },
  },
  {
    id: 'brook-15',
    avatarId: 'soul-musician',
    text: {
      es: 'Me quedé sin palabras... ¡y sin piel! ¡Chiste de calavera, yohohoho!',
      en: "I'm speechless... and skinless! Skull joke, yohohoho!",
    },
  },

  // ============================================
  // Francotirador Valiente (Usopp) - brave-sniper
  // ============================================
  {
    id: 'usopp-1',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Soy el gran Capitán Usopp, con 8000 seguidores!',
      en: "I'm the great Captain Usopp, with 8000 followers!",
    },
  },
  {
    id: 'usopp-2',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Sufro de la enfermedad de no-puedo-entrar-a-esta-isla!',
      en: "I have the can't-go-into-this-island disease!",
    },
  },
  {
    id: 'usopp-3',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Algún día seré un valiente guerrero del mar!',
      en: "Someday I'll be a brave warrior of the sea!",
    },
  },
  {
    id: 'usopp-4',
    avatarId: 'brave-sniper',
    text: {
      es: 'Hay que plantarse firme cuando se ríen del sueño de un amigo.',
      en: "You have to stand firm when someone laughs at a friend's dream.",
    },
  },
  {
    id: 'usopp-5',
    avatarId: 'brave-sniper',
    text: {
      es: 'Incluso un cobarde puede ser valiente cuando protege a sus amigos.',
      en: 'Even a coward can be brave when protecting their friends.',
    },
  },
  {
    id: 'usopp-6',
    avatarId: 'brave-sniper',
    text: {
      es: 'A veces mis mentiras se hacen realidad.',
      en: 'Sometimes my lies come true.',
    },
  },
  {
    id: 'usopp-7',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Soy Sogeking, el rey de los francotiradores!',
      en: "I'm Sogeking, the King of Snipers!",
    },
  },
  {
    id: 'usopp-8',
    avatarId: 'brave-sniper',
    text: {
      es: '¡El verdadero valor no es no tener miedo, es actuar a pesar del miedo!',
      en: "True courage isn't being fearless, it's acting despite the fear!",
    },
  },
  {
    id: 'usopp-9',
    avatarId: 'brave-sniper',
    text: {
      es: 'Me tiemblan las piernas... ¡pero no me voy a mover de aquí!',
      en: "My legs are shaking... but I'm not moving from here!",
    },
  },
  {
    id: 'usopp-10',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Mi papá es un gran pirata!',
      en: 'My dad is a great pirate!',
    },
  },
  {
    id: 'usopp-11',
    avatarId: 'brave-sniper',
    text: {
      es: 'Si tengo miedo, lo grito... ¡y sigo adelante!',
      en: "If I'm scared, I scream... and keep going!",
    },
  },
  {
    id: 'usopp-12',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Cada tropiezo me hace más fuerte para el siguiente intento!',
      en: 'Every stumble makes me stronger for the next try!',
    },
  },
  {
    id: 'usopp-13',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Tengo la mejor puntería de todo el mar!',
      en: 'I have the best aim on the whole sea!',
    },
  },
  {
    id: 'usopp-14',
    avatarId: 'brave-sniper',
    text: {
      es: 'Un día mis historias serán realidad, ¡y seré una leyenda!',
      en: "One day my stories will come true, and I'll be a legend!",
    },
  },
  {
    id: 'usopp-15',
    avatarId: 'brave-sniper',
    text: {
      es: '¡Soy un hombre! ¡No voy a huir!',
      en: "I'm a man! I won't run away!",
    },
  },

  // ============================================
  // Timonel Sabio (Jinbe) - wise-helmsman
  // ============================================
  {
    id: 'jinbe-1',
    avatarId: 'wise-helmsman',
    text: {
      es: 'No pienses en lo que perdiste. ¡Cuenta lo que todavía tienes!',
      en: "Don't think about what you've lost. Count what you still have!",
    },
  },
  {
    id: 'jinbe-2',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Paso a paso: hasta el mar más bravo se cruza con calma.',
      en: 'Step by step: even the roughest sea is crossed with calm.',
    },
  },
  {
    id: 'jinbe-3',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Un buen timonel no suelta el timón, ni en la peor tormenta.',
      en: 'A good helmsman never lets go of the helm, even in the worst storm.',
    },
  },
  {
    id: 'jinbe-4',
    avatarId: 'wise-helmsman',
    text: {
      es: 'El karate me enseñó disciplina y respeto.',
      en: 'Karate taught me discipline and respect.',
    },
  },
  {
    id: 'jinbe-5',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Un error no define a nadie. Lo que importa es lo que haces después.',
      en: "A mistake doesn't define anyone. What matters is what you do next.",
    },
  },
  {
    id: 'jinbe-6',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Cuando la tripulación rema junta, ninguna corriente es demasiado fuerte.',
      en: 'When the crew rows together, no current is too strong.',
    },
  },
  {
    id: 'jinbe-7',
    avatarId: 'wise-helmsman',
    text: {
      es: 'El mar premia a quien lo respeta.',
      en: 'The sea rewards those who respect it.',
    },
  },
  {
    id: 'jinbe-8',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Luffy-kun, confío en ti.',
      en: 'Luffy-kun, I trust you.',
    },
  },
  {
    id: 'jinbe-9',
    avatarId: 'wise-helmsman',
    text: {
      es: 'La fuerza sin propósito no sirve de nada.',
      en: 'Strength without purpose is worthless.',
    },
  },
  {
    id: 'jinbe-10',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Déjenme el timón a mí.',
      en: 'Leave the helm to me.',
    },
  },
  {
    id: 'jinbe-11',
    avatarId: 'wise-helmsman',
    text: {
      es: 'El respeto se gana con hechos, no con palabras.',
      en: 'Respect is earned with actions, not words.',
    },
  },
  {
    id: 'jinbe-12',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Agradece a quienes te enseñaron. Nadie llega lejos solo.',
      en: 'Thank those who taught you. Nobody gets far alone.',
    },
  },
  {
    id: 'jinbe-13',
    avatarId: 'wise-helmsman',
    text: {
      es: 'El mar es mi hogar.',
      en: 'The sea is my home.',
    },
  },
  {
    id: 'jinbe-14',
    avatarId: 'wise-helmsman',
    text: {
      es: 'La paciencia es una gran virtud.',
      en: 'Patience is a great virtue.',
    },
  },
  {
    id: 'jinbe-15',
    avatarId: 'wise-helmsman',
    text: {
      es: 'Soy Jinbe, timonel de los Sombrero de Paja.',
      en: 'I am Jinbe, helmsman of the Straw Hat Pirates.',
    },
  },
]

// Storage key for tracking shown quotes
const QUOTES_INDEX_KEY = 'invosloth_quotes_index'

/**
 * Get stored quote indices for each avatar
 */
function getStoredIndices(): Record<string, number> {
  try {
    const stored = localStorage.getItem(QUOTES_INDEX_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch {
    return {}
  }
}

/**
 * Save quote indices to localStorage
 */
function saveIndices(indices: Record<string, number>): void {
  try {
    localStorage.setItem(QUOTES_INDEX_KEY, JSON.stringify(indices))
  } catch {
    // Ignore localStorage errors
  }
}

/**
 * Get quotes for a specific avatar
 */
export function getQuotesForAvatar(avatarId: string): Quote[] {
  return quotes.filter((q) => q.avatarId === avatarId)
}

/**
 * Get the next quote in sequence for an avatar (cycles through all 15)
 */
export function getNextQuoteForAvatar(avatarId: string): Quote {
  const avatarQuotes = getQuotesForAvatar(avatarId)
  if (avatarQuotes.length === 0) {
    // Fallback to general quotes if avatar not found
    return getNextGeneralQuote()
  }

  const indices = getStoredIndices()
  const currentIndex = indices[avatarId] ?? 0
  const nextIndex = (currentIndex + 1) % avatarQuotes.length

  // Save the new index
  indices[avatarId] = nextIndex
  saveIndices(indices)

  return avatarQuotes[nextIndex]
}

/**
 * Get the current quote for an avatar (without advancing)
 */
export function getCurrentQuoteForAvatar(avatarId: string): Quote {
  const avatarQuotes = getQuotesForAvatar(avatarId)
  if (avatarQuotes.length === 0) {
    return quotes[0]
  }

  const indices = getStoredIndices()
  const currentIndex = indices[avatarId] ?? 0

  return avatarQuotes[currentIndex % avatarQuotes.length]
}

/**
 * Get the next general quote (cycles through all quotes)
 */
export function getNextGeneralQuote(): Quote {
  const indices = getStoredIndices()
  const currentIndex = indices['_general'] ?? 0
  const nextIndex = (currentIndex + 1) % quotes.length

  indices['_general'] = nextIndex
  saveIndices(indices)

  return quotes[nextIndex]
}

/**
 * Get a random quote (legacy function for backwards compatibility)
 */
export function getRandomQuote(): Quote {
  return getNextGeneralQuote()
}

/**
 * Get a random quote for a specific avatar (legacy function)
 */
export function getRandomQuoteForAvatar(avatarId: string): Quote | undefined {
  const avatarQuotes = getQuotesForAvatar(avatarId)
  if (avatarQuotes.length === 0) return undefined
  return getCurrentQuoteForAvatar(avatarId)
}

/**
 * Get quote text in the specified language
 */
export function getQuoteText(quote: Quote, lang: 'es' | 'en' = 'es'): string {
  return quote.text[lang] || quote.text.es
}
